import React, { ErrorInfo, PropsWithChildren } from 'react';
import { Button } from 'antd';
import * as Sentry from '@sentry/react';

interface IComponentState {
  hasError: boolean;
}

export class UIErrorHandler extends React.Component<PropsWithChildren, IComponentState> {
  static getDerivedStateFromError() {
    return { hasError: true };
  }

  constructor(props: PropsWithChildren) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    if (!error) {
      return;
    }

    console.error('UI Error:', error, errorInfo);

    Sentry.captureException(error, {
      extra: {
        componentStack: errorInfo.componentStack,
      },
    });
  }

  handleReload = () => {
    this.setState({ hasError: false });
    window.location.reload();
  };

  render() {
    const { hasError } = this.state;
    return !hasError ? (
      this.props.children
    ) : (
      <div className="redesign h-full flex direction-column align-center justify-center">
        <div className="mb-10 ff-regular fs-xl">
          Произошла ошибка при загрузке данных. Обновите страницу или попробуйте зайти позже.
        </div>

        <Button className="button-sm primary" onClick={this.handleReload}>
          Обновить страницу
        </Button>
      </div>
    );
  }
}
